const StackTrace = require('stacktrace-js/dist/stacktrace');

/*@ngInject*/
const LogUtil = function ($q, $log, $window, $state, $stateParams, appTypeConfigurationModel, logRepository, coreConstant, loginTokenRepository) {

    function log(logLevel, message, context, stacktrace) {
        let log = {
                clientType: 'HTML',
                timestamp: moment().format('YYYY-MM-DD HH:mm:ss,SSS'),
                message: message,
                context: context
            },
            defer = $q.defer();
        if (stacktrace) {
            log.stacktrace = stacktrace;
        }

        logRepository.log(log, logLevel).finally(function () {
            defer.resolve(log);
        });

        return defer.promise;
    }

    function buildContext(url) {
        let context = {
            browser: $window.navigator.userAgent,
            location: $window.location.href,
            state: $state.current.name
        };
        _.assignIn(context, $stateParams);
        if (url) {
            context.url = url;
        }

        return context;
    }

    this.logError = function (error, url) {
        if (!_.isNil(loginTokenRepository.getLoginToken())) {
            return StackTrace.fromError(error, {offline: true}).then(function (stackframes) {
                let errorMessage = error.name + ': ' + error.message,
                    // Parse the stackframes into a nice format:
                    stacktrace = _.join(_.map(stackframes, function (sf) {
                        if (sf.fileName === '(native)') {
                            return '\tat ' + sf.functionName + ' ' + sf.fileName;
                        } else {
                            return '\tat ' + sf.functionName + ' (' + sf.fileName + ':' + sf.lineNumber + ':' + sf.columnNumber + ')';
                        }
                    }), '\n');
                stacktrace = errorMessage + '\n' + stacktrace;

                return log('ERROR', errorMessage, buildContext(url), stacktrace);
            }).catch(function (error) {
                $log.error(error);
            });
        } else {
            return $q.when();
        }
    };

    this.logWarning = function (message) {
        return log('WARN', message, buildContext());
    };

    this.logInfo = function (message) {
        return log('INFO', message, buildContext());
    };

    this.logDebug = function (message) {
        return log('DEBUG', message, buildContext());
    };

    this.logTrace = function (message) {
        return log('TRACE', message, buildContext());
    };
};

angular.module('umCore')
    .service('logUtil', LogUtil);
